module.exports = __webpack_public_path__ + "static/img/ZRS4268_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ZRS4268_1.png
// module id = Ua4n
// module chunks = 0